export default __webpack_public_path__ + "static/media/info-icon.05e9b4d7.svg";